import SetFiscalRegimeError from './SetFiscalRegimeError';
class InvestorHasFiscalRegimeInProcess extends SetFiscalRegimeError {
    constructor(options) {
        super('Investor trying to set a fiscal regime when investor is already in process', options);
    }
}
export default InvestorHasFiscalRegimeInProcess;
